import {auctionContractAddress, ListingType, marketplaceContractAddress} from "./blockchainInteractor";
import {
    balanceOfAddressERC721,
    getOwnerFromERCByTokenId,
    getTokensOfAddressERC721,
} from "./erc721Interactor";
import {
    balanceOfAddressMarketplace, getAllTokensMarketPlace,
    getMarketPlaceTokenByTokenId,
    getTokensOfAddressMarketplace, getTotalListedMarketplace
} from "./marketPlaceInteractor";
import {getMetaForMany} from "../services/metaService";
import { getAuctionInfo, index } from "./auctionInteractor";

export async function getStoreFrontNFTS(){
    let storeNFTs = [];
    const totalListedMarketplaceCount = await getTotalListedMarketplace();
    const ErcBalance = await balanceOfAddressERC721(auctionContractAddress);
    if(Number(ErcBalance)){
        const ERCTokens =  await getTokensOfAddressERC721(auctionContractAddress, 0, ErcBalance);   
        for(let i in ERCTokens)
        storeNFTs.push({tokenId: ERCTokens[i], listingType : ListingType.AUCTION,
            owner : auctionContractAddress
        });
    }
    if(Number(totalListedMarketplaceCount)){
        const MarketplaceTokens = await getAllTokensMarketPlace(0, totalListedMarketplaceCount);
        const {_prices,_tokens,_owners,_priceTypes } = MarketplaceTokens;
        if(_owners && _owners.length){
            for(let i=0;i<_tokens.length;i++){
                storeNFTs.push({tokenId:_tokens[i],price:_prices[i],owner:_owners[i],priceType:_priceTypes[i], listingType : ListingType.MARKETPLACE})
            }
        }
    }
    return storeNFTs;
};

export async function getUserNFTs(address){
    let UserNFTs = [];
    const ErcBalance = await balanceOfAddressERC721(address);
    const marketPlaceBalance = await balanceOfAddressMarketplace(address);
    if(Number(ErcBalance)){
        const ERCTokens =  await getTokensOfAddressERC721(address, 0, ErcBalance);
        for(let i in ERCTokens)
        UserNFTs.push({tokenId: ERCTokens[i], listingType : ListingType.NOT_LISTED,
            owner : address
        });

    console.log(ERCTokens,ErcBalance);
    }
    if(Number(marketPlaceBalance)){
        const MarketplaceTokens = await getTokensOfAddressMarketplace(address,0, marketPlaceBalance);

        const {_prices,_tokens,_owners,_priceTypes } = MarketplaceTokens;
        if(_owners && _owners.length){
            for(let i=0;i<_tokens.length;i++){
                UserNFTs.push({tokenId:_tokens[i],price:_prices[i],owner:_owners[i],priceType:_priceTypes[i], listingType : ListingType.MARKETPLACE});
            }
        }
    }
    console.log(UserNFTs);
    return UserNFTs;
}
export async function getTokenInfo(tokenId){
    let tokenInfo = {};
    const owner = await getOwnerFromERCByTokenId(tokenId);
    let listingType  = ListingType.NOT_LISTED
    if(owner.toLowerCase() === marketplaceContractAddress.toLowerCase()){
        listingType = ListingType.MARKETPLACE;
        const token = await getMarketPlaceTokenByTokenId(tokenId);
        if(token){
            const {_price,_priceType,_owner} = token;
            tokenInfo = {price:_price,priceType:_priceType,owner:_owner,listingType}
        }
    }else if(owner.toLowerCase() === auctionContractAddress.toLowerCase()){
        listingType = ListingType.AUCTION;
        tokenInfo = {owner,listingType}
    }
    else{
      tokenInfo = {owner,listingType}
    }
    return tokenInfo;
}
export async function  getAllNFTs(address){
    let nfts = !address ? await getStoreFrontNFTS() : await getUserNFTs(address);
    const lastAuctionIndex = await index();
    for(let i=0;i<lastAuctionIndex;i++){
        const auction = await getAuctionInfo(i);
       const idx = nfts.findIndex(nft => nft.tokenId === auction.nftId);
       if(idx>-1){
        const { addressNFTCollection, addressPaymentToken, bidCount, creator, currentBidOwner, currentBidPrice, endAuction, index } = auction;
        nfts[idx] = { ...nfts[idx], addressNFTCollection, addressPaymentToken, bidCount, creator, currentBidOwner, currentBidPrice, endAuction, index };
       }
    }
    const tokenIDs = [];
    for(const token of nfts)
        tokenIDs.push(token.tokenId);
    let metaDatas = await getMetaForMany({tokenIDs});
    for(let i=0;i<nfts.length;i++)
        nfts[i] = {...nfts[i],...metaDatas.data[i]};
    return nfts;
}
